export enum LeadCategoryEnum {
  SALES_LEAD = 'SalesLead',
  RECRUIT_LEAD = 'RecruitLead',
}
